export const mySkills = [
  {
    label: "Front End",
    skills: [
      {
        language: "HTML5",
        knowledge: "90",
      },
      {
        language: "CSS3",
        knowledge: "80",
      },
      {
        language: "JAVASCRIPT",
        knowledge: "70",
      },
      {
        language: "REACT JS",
        knowledge: "60",
      },
      {
        language: "REDUX",
        knowledge: "55",
      },
    ],
  },
  {
    label: "Back End",
    skills: [
      {
        language: "EXPRESS JS",
        knowledge: "40",
      },
      {
        language: "NODE JS",
        knowledge: "50",
      },
      {
        language: "PHP",
        knowledge: "20",
      },
    ],
  },
  {
    label: "Database",
    skills: [
      {
        language: "Mongodb",
        knowledge: "70",
      },
    ],
  },
];
